<script>
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "JoinedAtDate",
  extends: TextElement,
  mixins: [UserProfilePageElementMixin, DateElementMixin],
  elementPanelSettings: {
    displayName: "Joined At Date",
    displayIcon: "document",
    elementGroup: "userProfile",
    elementType: "element",
  },
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return `Joined ${this.formattedDate(this.entity.dateCreated)}`;
    },
    shouldShowText() {
      return this.entity.dateCreated;
    },
  },
};
</script>
